import isBrowserContext from "helpers/isBrowserContext";
import { useEffect, useState } from "react";


export default () => {
    const [windowDimensions, setWindowDimensions] = useState<any>({
        width: 1280,
        height: 1280,
        device: "desktop"
    });

    const getDeviceType = (window: any) => {
        const ua = window?.navigator?.userAgent;

        if (ua && /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        else if (ua && /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }

        return "desktop";
    };

    const getWindowDimensions = () => {
        const w = isBrowserContext() ? window : undefined;
        return {
            width: w?.innerWidth ?? 1280,
            height: w?.innerHeight ?? 1280,
            device: getDeviceType(w)
        };
    };

    useEffect(() => {
        setWindowDimensions(getWindowDimensions());

        const resizeHandler = () => {
            setWindowDimensions(getWindowDimensions());
        };

        if(!isBrowserContext()) return

        window.addEventListener("resize", resizeHandler);
        return () => window.removeEventListener("resize", resizeHandler);
    }, []);

    return windowDimensions;
};

